import { Switch } from 'react-router';
import PrivateRoute from '../../@shared/Routes/PrivateRoute';
import ReportsPage from './reports';

const baseUrl = '/reports';

export const reportsPagesRoutes = {
  baseUrl,
};

const ReportsRoutes = () => (
  <Switch>
    <PrivateRoute path={baseUrl} exact requiredPermissions={['admin-reports:read']}>
      <ReportsPage />
    </PrivateRoute>
  </Switch>
);

export default ReportsRoutes;
